// extracted by mini-css-extract-plugin
export default {"blue":"styles_blue__Rznu9","orange":"styles_orange__BZkux"};